<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">{{ 'FLUJOVENTA.LBL_FLUJOVENTA' | translate }}</h1>
  </div>
</div>

<app-loading *ngIf="cargando"></app-loading>

<div *ngIf="!cargando">
  <app-loading [hidden]="!actSecuencia && !destruirTab"></app-loading>
  <div [hidden]="actSecuencia || destruirTab">
    <div class="grid" *ngIf="!destruirTab">
      <div class="col-12 md:col-12 lg:col-12" class="div-encabezado">
        <p-scrollPanel>
          <div [sortablejs]="listadoKey" [sortablejsOptions]="opcionesSort" class="items">
            <div *ngFor="let key of listadoKey; let i = index" class="item"
                 [ngClass]="{'item-seleccionado': pasos[key].objeto.active, 'item-disponible': !pasos[key].objeto.active, 'item-sinmovimiento': pasos[key].objeto.disabled }"
                 (mousedown)="pasos[key].objeto.disabled ? $event.preventDefault() : {}"
                 (click)="pasos[key].objeto.active ? $event.preventDefault() : seleccionar($event,i)">{{ pasos[key].objeto.nombre }}</div>
          </div>
        </p-scrollPanel>
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12 div-cuerpo">
        <p-panel header="{{ 'FLUJOVENTA.LBL_DATOBASICO' | translate}}"
                 [hidden]="keySeleccionada !== pasosEnum.DATOSBASICOS">
          <app-flujo-venta-agregar-tabla [tabView]="pasos[pasosEnum.DATOSBASICOS].objeto"
                                         [lisPasos]="listadoFlujoVenta" [secFija]="true"
                                         [lisVinculacion]="lisVinculacion"
                                         [lisTipoPersonas]="listasTiposPersonas"
                                         *ngIf="keySeleccionada && pasos[pasosEnum.DATOSBASICOS].objeto"></app-flujo-venta-agregar-tabla>
        </p-panel>

        <app-flujo-venta-unidad-productiva
                                        [hidden]="keySeleccionada !== pasosEnum.UNIDADPRODUCTIVA"
                                        *ngIf="keySeleccionada && pasos[pasosEnum.UNIDADPRODUCTIVA].objeto"
                                        [tabView]="pasos[pasosEnum.UNIDADPRODUCTIVA].objeto"
                                        [lisPasos]="listadoFlujoVenta"
                                        [listaSecuencias]="pasos[pasosEnum.UNIDADPRODUCTIVA].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                        [listaVinculaciones]="lisVinculacion"
                                        [listaTiposPersonas]="listasTiposPersonas"
                                        [titulo]="'FLUJOVENTA.LBL_UNIDADPRODUCTIVA' | translate"
        >
        </app-flujo-venta-unidad-productiva>

        <app-flujo-venta-unidad-familiar
                                        [hidden]="keySeleccionada !== pasosEnum.UNIDADFAMILIAR"
                                        *ngIf="keySeleccionada && pasos[pasosEnum.UNIDADFAMILIAR].objeto"
                                        [tabView]="pasos[pasosEnum.UNIDADFAMILIAR].objeto"
                                        [listaSecuencias]="pasos[pasosEnum.UNIDADFAMILIAR].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                        [listaVinculaciones]="lisVinculacion"
                                        [lisPasos]="listadoFlujoVenta"
                                        [listaTiposPersonas]="listasTiposPersonas"
                                        [titulo]="'FLUJOVENTA.LBL_UNIDADFAMILIAR' | translate"
        >
        </app-flujo-venta-unidad-familiar>

        <app-flujo-venta-listado-adjuntos
                                        [hidden]="keySeleccionada !== pasosEnum.ADJUNTOS"
                                        *ngIf="keySeleccionada && pasos[pasosEnum.ADJUNTOS].objeto"
                                        [titulo]="'FLUJOVENTA.LBL_LISTADJUNTOS' | translate"
                                        [tabView]="pasos[pasosEnum.ADJUNTOS].objeto"
                                        [listaSecuencias]="pasos[pasosEnum.ADJUNTOS].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                        [listaVinculaciones]="lisVinculacion"
                                        [listaTiposPersonas]="listasTiposPersonas"
                                        [lisPasos]="listadoFlujoVenta"
        ></app-flujo-venta-listado-adjuntos>

        <app-flujo-venta-hoja-evaluacion
                                        [hidden]="keySeleccionada !== pasosEnum.HOJAEVALUACION"
                                        *ngIf="keySeleccionada && pasos[pasosEnum.HOJAEVALUACION].objeto"
                                        [tabView]="pasos[pasosEnum.HOJAEVALUACION].objeto"
                                        [listaSecuencias]="pasos[pasosEnum.HOJAEVALUACION].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                        [listaVinculaciones]="lisVinculacion"
                                        [lisPasos]="listadoFlujoVenta"
                                        [listaTiposPersonas]="listasTiposPersonas"
                                        [titulo]="'FLUJOVENTA.LBL_HOJAEVALUACION' | translate"
        >
        </app-flujo-venta-hoja-evaluacion>

        <app-flujo-venta-respaldos
                                  [hidden]="keySeleccionada !== pasosEnum.RESPALDOS"
                                  *ngIf="keySeleccionada && pasos[pasosEnum.RESPALDOS].objeto"
                                  [tabView]="pasos[pasosEnum.RESPALDOS].objeto"
                                  [listaSecuencias]="pasos[pasosEnum.RESPALDOS].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                  [listaVinculaciones]="lisVinculacion"
                                  [lisPasos]="listadoFlujoVenta"
                                  [listaTiposPersonas]="listasTiposPersonas"
                                  [titulo]="'FLUJOVENTA.LBL_RESPALDOS' | translate"
        >
        </app-flujo-venta-respaldos>

        <app-flujo-venta-politicas
                                  [hidden]="keySeleccionada !== pasosEnum.POLITICA"
                                  *ngIf="keySeleccionada && pasos[pasosEnum.POLITICA].objeto"
                                  [tabView]="pasos[pasosEnum.POLITICA].objeto"
                                  [listaSecuencias]="pasos[pasosEnum.POLITICA].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                  [listaVinculaciones]="lisVinculacion"
                                  [lisPasos]="listadoFlujoVenta"
                                  [listaTiposPersonas]="listasTiposPersonas"
                                  [titulo]="'FLUJOVENTA.LBL_POLITICAS' | translate"
        ></app-flujo-venta-politicas>

        <app-flujo-venta-seguro  [hidden]="keySeleccionada !== pasosEnum.SEGURO"
                                 *ngIf="keySeleccionada && pasos[pasosEnum.SEGURO].objeto"
                                 [tabView]="pasos[pasosEnum.SEGURO].objeto"
                                 [listaSecuencias]="pasos[pasosEnum.SEGURO].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                 [listaVinculaciones]="lisVinculacion"
                                 [lisPasos]="listadoFlujoVenta"
                                 [listaTiposPersonas]="listasTiposPersonas"
                                 [titulo]="'FLUJOVENTA.LBL_SEGURO' | translate"></app-flujo-venta-seguro>

        <app-flujo-venta-comite-credito
                                 [hidden]="keySeleccionada !== pasosEnum.COMITECREDITO"
                                 *ngIf="keySeleccionada && pasos[pasosEnum.COMITECREDITO].objeto"
                                 [titulo]="'FLUJOVENTA.LBL_COMITECREDITO' | translate"
                                 [tabView]="pasos[pasosEnum.COMITECREDITO].objeto"
                                 [listaSecuencias]="pasos[pasosEnum.COMITECREDITO].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                 [listaVinculaciones]="lisVinculacion"
                                 [listaTiposPersonas]="listasTiposPersonas"
                                 [lisPasos]="listadoFlujoVenta"></app-flujo-venta-comite-credito>

        <app-flujo-venta-complementario [tabView]="pasos[pasosEnum.COMPLEMENTARIOS].objeto"
                                        [lisPasos]="listadoFlujoVenta" [secFija]="false"
                                        [lisVinculacion]="lisVinculacion"
                                        [listaTiposPersonas]="listasTiposPersonas"
                                        [lisAutorizaciones]="lisAutorizaciones"
                                        [lisPlantilla]="lisPlantillas"
                                        [lisFases]="lisFases" [titulo]="'FLUJOVENTA.LBL_COMPLEMENTARIOS' | translate"
                                        [lisSecuencia]="pasos[pasosEnum.COMPLEMENTARIOS].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                        [hidden]="keySeleccionada !== pasosEnum.COMPLEMENTARIOS"
                                        *ngIf="keySeleccionada && pasos[pasosEnum.COMPLEMENTARIOS].objeto"></app-flujo-venta-complementario>
        <app-flujo-venta-autorizaciones [tabView]="pasos[pasosEnum.AUTORIZACIONES].objeto"
                                        [lisPasos]="listadoFlujoVenta" [secFija]="false"
                                        [listaVinculaciones]="lisVinculacion"
                                        [lisAutorizaciones]="lisAutorizaciones"
                                        [lisFases]="lisFases"
                                        [lisPlantilla]="lisPlantillas"
                                        [lisEstados]="lisEstados"
                                        [listaTiposPersonas]="listasTiposPersonas"
                                        [listasTiposProductosBancarios]="listasTiposProductosBancarios"
                                        [titulo]="'FLUJOVENTA.LBL_AUTORIZACIONES' | translate"
                                        [listaSecuencias]="pasos[pasosEnum.AUTORIZACIONES].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                        [hidden]="keySeleccionada !== pasosEnum.AUTORIZACIONES"
                                        *ngIf="keySeleccionada && pasos[pasosEnum.AUTORIZACIONES].objeto"></app-flujo-venta-autorizaciones>
        <app-flujo-venta-consulta [tabView]="pasos[pasosEnum.CONSULTAS].objeto"
                                  [lisPasos]="listadoFlujoVenta" [secFija]="false"
                                  [listaVinculaciones]="lisVinculacion"
                                  [listasTiposOcupaciones]="listasTiposOcupaciones"
                                  [listaTiposPersonas]="listasTiposPersonas"
                                  [titulo]="'FLUJOVENTA.LBL_CONSULTAS' | translate"
                                  [listaSecuencias]="pasos[pasosEnum.CONSULTAS].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                  [lisIntegraciones]="lisIntegraciones"
                                  [hidden]="keySeleccionada !== pasosEnum.CONSULTAS"
                                  *ngIf="keySeleccionada && pasos[pasosEnum.CONSULTAS].objeto"></app-flujo-venta-consulta>
        <app-flujo-venta-fin-proceso [tabView]="pasos[pasosEnum.FINPROCESO].objeto"
                                     [lisPasos]="listadoFlujoVenta" [secFija]="false"
                                     [listaVinculaciones]="lisVinculacion"
                                     [titulo]="'FLUJOVENTA.LBL_FINPROCESO' | translate"
                                     [listaSecuencias]="pasos[pasosEnum.FINPROCESO].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                     [hidden]="keySeleccionada !== pasosEnum.FINPROCESO"
                                     *ngIf="keySeleccionada && pasos[pasosEnum.FINPROCESO].objeto"></app-flujo-venta-fin-proceso>
        <app-flujo-venta-historial-credito [tabView]="pasos[pasosEnum.HISTORIALCREDITO].objeto"
                                           [lisPasos]="listadoFlujoVenta" [secFija]="false"
                                           [listaVinculaciones]="lisVinculacion"
                                           [listaTiposPersonas]="listasTiposPersonas"
                                           [lisAutorizaciones]="lisAutorizaciones"
                                           [lisFases]="lisFases" [lisEstados]="lisEstados"
                                           [titulo]="'FLUJOVENTA.LBL_HISTORIALCREDITO' | translate"
                                           [lisPlantilla]="lisPlantillas"
                                           [listasTiposProductosBancarios]="listasTiposProductosBancarios"
                                           [listaSecuencias]="pasos[pasosEnum.HISTORIALCREDITO].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                           [hidden]="keySeleccionada !== pasosEnum.HISTORIALCREDITO"
                                           *ngIf="keySeleccionada && pasos[pasosEnum.HISTORIALCREDITO].objeto"></app-flujo-venta-historial-credito>
        <app-flujo-venta-oferta [tabView]="pasos[pasosEnum.OFERTA].objeto"
                                [lisPasos]="listadoFlujoVenta" [secFija]="false"
                                [listaVinculaciones]="lisVinculacion"
                                [listaTiposPersonas]="listasTiposPersonas"
                                [titulo]="'FLUJOVENTA.LBL_OFERTA' | translate"
                                [listaSecuencias]="pasos[pasosEnum.OFERTA].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                [hidden]="keySeleccionada !== pasosEnum.OFERTA"
                                *ngIf="keySeleccionada && pasos[pasosEnum.OFERTA].objeto"></app-flujo-venta-oferta>
        <app-flujo-venta-referencia [tabView]="pasos[pasosEnum.REFERENCIA].objeto"
                                    [lisPasos]="listadoFlujoVenta" [secFija]="false"
                                    [listaVinculaciones]="lisVinculacion"
                                    [listaTiposPersonas]="listasTiposPersonas"
                                    [titulo]="'FLUJOVENTA.LBL_REFERENCIAS' | translate"
                                    [listaSecuencias]="pasos[pasosEnum.REFERENCIA].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                    [hidden]="keySeleccionada !== pasosEnum.REFERENCIA"
                                    *ngIf="keySeleccionada && pasos[pasosEnum.REFERENCIA].objeto"></app-flujo-venta-referencia>
        <app-flujo-venta-requisito [tabView]="pasos[pasosEnum.REQUISITO].objeto"
                                   [lisPasos]="listadoFlujoVenta" [secFija]="false"
                                   [listaVinculaciones]="lisVinculacion"
                                   [listaTiposPersonas]="listasTiposPersonas"
                                   [titulo]="'FLUJOVENTA.LBL_REQUISITOS' | translate"
                                   [listaSecuencias]="pasos[pasosEnum.REQUISITO].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                   [hidden]="keySeleccionada !== pasosEnum.REQUISITO"
                                   *ngIf="keySeleccionada && pasos[pasosEnum.REQUISITO].objeto"></app-flujo-venta-requisito>
        <app-flujo-venta-segmento [tabView]="pasos[pasosEnum.SEGMENTOS].objeto"
                                  [lisPasos]="listadoFlujoVenta" [secFija]="false"
                                  [listaVinculaciones]="lisVinculacion"
                                  [listaTiposPersonas]="listasTiposPersonas"
                                  [titulo]="'FLUJOVENTA.LBL_SEGMENTO' | translate"
                                  [listaSecuencias]="pasos[pasosEnum.SEGMENTOS].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                  [hidden]="keySeleccionada !== pasosEnum.SEGMENTOS"
                                  *ngIf="keySeleccionada && pasos[pasosEnum.SEGMENTOS].objeto"></app-flujo-venta-segmento>
        <app-flujo-venta-unidad-credito [tabView]="pasos[pasosEnum.UNIDADCREDITO].objeto"
                                        [lisPasos]="listadoFlujoVenta" [secFija]="false"
                                        [listaVinculaciones]="lisVinculacion"
                                        [listaTiposPersonas]="listasTiposPersonas"
                                        [titulo]="'FLUJOVENTA.LBL_UNIDADCREDITO' | translate"
                                        [listaSecuencias]="pasos[pasosEnum.UNIDADCREDITO].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                        [hidden]="keySeleccionada !== pasosEnum.UNIDADCREDITO"
                                        *ngIf="keySeleccionada && pasos[pasosEnum.UNIDADCREDITO].objeto"></app-flujo-venta-unidad-credito>
        <app-flujo-venta-validacion-identidad [tabView]="pasos[pasosEnum.VALIDACIONIDENTIDAD].objeto"
                                              [lisPasos]="listadoFlujoVenta" [secFija]="false"
                                              [listaVinculaciones]="lisVinculacion"
                                              [listaTiposPersonas]="listasTiposPersonas"
                                              [titulo]="'FLUJOVENTA.LBL_VALIDACIONIDENTIDAD' | translate"
                                              [lisEstados]="lisEstados"
                                              [listaSecuencias]="pasos[pasosEnum.VALIDACIONIDENTIDAD].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                              [hidden]="keySeleccionada !== pasosEnum.VALIDACIONIDENTIDAD"
                                              *ngIf="keySeleccionada && pasos[pasosEnum.VALIDACIONIDENTIDAD].objeto"></app-flujo-venta-validacion-identidad>
        <app-flujo-venta-requisito [tabView]="pasos[pasosEnum.MONETIZACION].objeto"
                                              [lisPasos]="listadoFlujoVenta" [secFija]="false"
                                              [listaVinculaciones]="lisVinculacion"
                                              [listaTiposPersonas]="listasTiposPersonas"
                                              [titulo]="'FLUJOVENTA.LBL_MONETIZACION' | translate"
                                              [listaSecuencias]="pasos[pasosEnum.MONETIZACION].objeto.flujoVenta ? listadoSecuencia : listadoSecuenciaCreacion"
                                              [hidden]="keySeleccionada !== pasosEnum.MONETIZACION"
                                              *ngIf="keySeleccionada && pasos[pasosEnum.MONETIZACION].objeto"></app-flujo-venta-requisito>


      </div>
    </div>
  </div>
  <p-confirmDialog #cd key="flujo-venta">
    <p-footer>
      <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_ACEPTAR' | translate }}" (click)="cd.accept()"></button>
    </p-footer>
  </p-confirmDialog>

